<template lang="pug">
  div(v-loading="loading")
    el-card
      div(v-if="mensagens.mensagens")
        span.title {{ mensagens.assunto }}
        el-collapse(v-model="activeCollapse" accordion)
          el-collapse-item(name="1")
            template(slot="title")
              .title-collapse
                span.title-name {{ mensagens.mensagens[0].remetente.nomeRazaoSocial }}
                span.date {{ mensagens.mensagens[0].dataEnviada | timestamp }}
            .collapse-content
                span.content
                  div(v-html="mensagens.mensagens[0].conteudo ")
                el-divider
                div(v-if="mensagens.mensagens[0].anexos.length > 0")
                  div(v-for="(anexo, index) in mensagens.mensagens[0].anexos" :key="index")
                    el-divider(v-if="index > 0")
                    div.anexos
                      span.anexo-name {{ anexo.nome }}
                      div(class="fa fa-download icone-download" style="color: #666666;" @click="downloadAnexo(anexo)")
                div.sem-anexo(v-else) Não há anexos disponíveis.
                el-divider
        el-collapse(
          accordion
          v-for="(mensagem, index) in mensagens.mensagens"
          :key="index"
          v-if="index > 0"
          @change="handleChange(mensagem)"
        )
          el-collapse-item
            template(slot="title")
              .title-collapse
                span.title-name {{ mensagem.remetente.nomeRazaoSocial }}
                span.date {{ mensagem.dataEnviada | timestamp }}
            .collapse-content
                span.content
                  div(v-html="mensagem.conteudo")
                el-divider
                div(v-if="mensagem.anexos.length > 0")
                  div(v-for="(anexo, index) in mensagem.anexos" :key="index")
                    el-divider(v-if="index > 0")
                    div.anexos
                      span {{ anexo.nome }}
                      div(class="fa fa-download icone-download" style="color: #666666;" @click="downloadAnexo(anexo)")
                div.sem-anexo(v-else) Não há anexos disponíveis.
                el-divider(style="margin-bottom: 20px;")
      el-form(:model="formResposta" ref="formResposta" style="margin-top: 40px;" v-if="mensagens.tipoConversa === 'NOTIFICACAO' && mensagens.status !== 'ENCERRADA'")
        el-form-item(prop="mensagem")
          span.label &nbsp Mensagem
          span.required *
          vue-editor.campo-texto(
            :editor-toolbar="customToolbar"
            v-model="formResposta.mensagem"
            placeholder="Digite o texto..."
          )
        el-form-item.column
          .label Anexos da mensagem
          el-upload(
            class="upload-demo"
            drag
            :action='urlUpload'
            :headers="{ Authorization: token }"
            multiple
            :file-list='fileList'
            :on-success='updateAnexosId'
            :before-upload='checkFile'
            :on-remove="removeFile"
          )
            div.el-upload__text
              span Arraste e solte ou clique para selecionar um arquivo.
              span Formatos suportados: png, jpg, jpeg, pdf, doc, docx, zip.
      div.buttons
        el-button(icon="el-icon-back" @click="cancelar()") Voltar
        el-button(type="primary" icon="el-icon-s-promotion" @click="submit()" v-if="mensagens.tipoConversa === 'NOTIFICACAO' && mensagens.status !== 'ENCERRADA'") Enviar
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { findConversaById, responderMensagem, marcarMensagemComoLida } from '@/services/conversaService';
import { findByCaminho } from '@/services/documentoService';
import { getUsuario } from '@/store/auth';
import { AppNotificacao } from 'sicarf-components';
import store from '@/store';

export default {
  components: {
    VueEditor,
  },
  mixins: [
    AppNotificacao
  ],
  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ clean: true }],
      ],
      formResposta: {
        mensagem: '',
      },
      urlUpload: `${process.env.VUE_APP_ROOT_URL}/publico/documentoCredenciado/upload`,
      token: `Bearer ${sessionStorage.getItem('jwtToken')}`,
      fileList: [],
      solicitacao: [],
      anexos: [],
      loading: true,
      mensagem: {},
      formatosPermitidos: ['pdf', 'rar', 'zip', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'],
      remetente: [],
      usuario: [],
      activeCollapse: '1',
      mensagens: [],
    }
  },
  async created() {
    this.mensagens = await findConversaById(this.$route.params.id);
    this.mensagens.mensagens.reverse();
    this.usuario = getUsuario();

    if (this.mensagens.mensagens[0].status !== 'LIDA' && this.mensagens.mensagens[0].remetente.cpfCnpj !== this.usuario.pessoa.cpfCnpj) {
      await marcarMensagemComoLida(this.mensagens.mensagens[0].id);
      this.updateBell();
    }

    if (this.mensagens.status === "ENCERRADA") {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Esta conversa foi encerrada. Não é possível enviar novas mensagens.')
    }

    this.loading = false;
  },
  methods: {
    async downloadAnexo(anexo) {
      const fileLink = document.createElement('a');

      const arquivo = await findByCaminho(anexo.caminho);

      if (arquivo) {
        const fileURL = new Blob([arquivo]);
        fileLink.href = window.URL.createObjectURL(fileURL);

        fileLink.setAttribute('download', anexo.nome);
        document.body.appendChild(fileLink);

        fileLink.click();
      }

      return Promise.resolve();
    },
    updateAnexosId(file, response) {
      this.anexos.push({ nome: response.name, key: file });
    },
    checkFile(file) {
      const tamanhoValido = file.size / 1024 / 1024 < 15;

      const showLoading = () => {
        store.commit('loader/SET_LOADER')
      }

      const hideLoading = () => {
        store.commit('loader/RESET_LOADER')
      }

      showLoading();

      let aux = file.name.split(".")
      const typeFile = aux[aux.length - 1]

      if (!this.formatosPermitidos.includes(typeFile.toLowerCase())) {
        this.showNotificacao(this.$messages.TIPO_ERROR, 'Formato de arquivo inválido!',
          'Formatos suportados: png, jpg, jpeg, pdf, doc, docx, zip.')
        hideLoading()
        return false;
      }

      if (!tamanhoValido) {
        hideLoading()
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
          'Arquivo deve ter no máximo 15MB de tamanho!')
        hideLoading()
        return false;
      }

      hideLoading()
      return true;
    },
    removeFile(file) {
      this.anexos = this.anexos.filter((doc) => doc.nome !== file.name);
    },
    cancelar() {
      if (this.formResposta.mensagem !== '' || this.anexos.length > 0) {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Mensagem cancelada.')
      }
      this.$router.push({path: '/credenciado/mensagens'});
    },
    async submit() {
      if (this.formResposta.mensagem !== '') {
        this.loading = true;
        const mensagem = {};
        mensagem.conteudo = this.formResposta.mensagem;
        mensagem.destinatario = this.mensagens.mensagens[0].remetente;
        mensagem.anexos = this.anexos;

        mensagem.conversa = {};
        mensagem.conversa.id = this.$route.params.id;
        try {
          await responderMensagem(mensagem);
          this.mensagens = await findConversaById(this.$route.params.id);
          this.mensagens.mensagens.reverse();
          this.formResposta.mensagem = '';
          this.anexos = [];
          this.fileList = [];
          this.loading = false;
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Mensagem enviada com sucesso.')
        } catch (e) {
          this.loading = false;
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Ocorreu um erro ao tentar enviar mensagem.')
        }
      } else {
        this.loading = false;
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo de mensagem.')
      }
    },
    async handleChange(val) {
      if (val.status !== 'LIDA' && val.remetente.cpfCnpj !== this.usuario.pessoa.cpfCnpj) {
        await marcarMensagemComoLida(val.id);
        this.updateBell();
      }
    },
    updateBell() {
      this.$root.$children[0].countNotifications();
    },
  },
}
</script>

<style>

.title {
  color: 606266;
  font-size: 20px;
  font-weight: bold;
}

.el-card {
  border-radius: 12px;
  padding: 6px;
}

.el-collapse {
  margin-top: 20px;
}

.title-collapse {
  font-size: 16px;
  font-weight: bold;
  color: #6a6a6a;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
}

.collapse-content {
  border-radius: 15px;
  display: flex;
  flex-direction: column !important;
}

.content {
  margin-bottom: 30px;
  font-size: 16px;
}

.date {
  font-size: 16px;
  font-weight: bold;
  color: #6a6a6a;
  margin-right: 20px;
}

.anexos {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  height: 24px;
  color: #666666;
}

.anexo-name {
  margin-left: 12px;
}

.sem-anexo{
  display: flex;
  flex-direction: column;;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #909399;
}

.icone-download {
  cursor: pointer !important;
  margin-right: 12px;
  margin-top: 5px;
}

.label {
  color: #606266;
  font-size: 16px;
  font-weight: bold;
  margin-right: 4px;
}

.campo-texto {
  margin-bottom: 22px !important;
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.el-divider--horizontal {
  margin: 10px 0px 10px 0px !important;
}

.el-upload__text {
  background: #d9d9d9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  line-height: 2em;
  height: 7rem;
}

.required {
  color: #F56C6C;
}

</style>
